import React from "react";

export default function HRStatCard({
  title,
  value,
  hint,
  onClick,
  className = "",
}) {
  const clickable = typeof onClick === "function";

  return (
    <div
      onClick={onClick}
      className={[
        "bg-white dark:bg-neutral-900 rounded-2xl shadow-sm border border-gray-200 dark:border-neutral-700 p-4 transition",
        clickable ? "cursor-pointer hover:shadow-md hover:-translate-y-[1px]" : "",
        className,
      ].join(" ")}
    >
      <div className="text-sm text-gray-500 dark:text-gray-400">{title}</div>
      <div className="text-2xl font-semibold mt-2 text-black dark:text-white">
        {value ?? 0}
      </div>
      {hint ? (
        <div className="text-xs text-gray-400 dark:text-gray-500 mt-2">
          {hint}
        </div>
      ) : null}
    </div>
  );
}